import { Select } from "../../../../components/forms/select";
import { useStates } from "../../../products/hooks/useStates";

interface StateSelectProps {
  value: string;
  countryId?: string | null;
  onChange: (value: string) => void;
  error?: string;
}

export function StateSelect({ value, countryId, onChange, error }: StateSelectProps) {
  const { data: states, isLoading } = useStates(countryId);

  const options =
    states?.map((state) => ({
      value: state.id.toString(),
      label: state.name,
    })) ?? [];

  return (
    <Select
      label="State / province"
      name="stateId"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Select a state"
      disabled={isLoading}
      options={options}
      error={error}
      helperText={isLoading ? "Loading states..." : countryId ? "" : "Select a country to narrow the list"}
    />
  );
}
